<template>
  <div>
    <h2>Assembly Planning Sheet</h2>
    <div class="filters" style="margin-bottom: 1em;">
    <button @click="openAddModal" style="margin-bottom: 1em; margin-right:50px; font-size:1em; padding: 12px 28px; min-width: 240px;">Add New Assembly Plan</button>
    <div v-for="col in filterableColumns" :key="col" style="display:inline-block; margin-right:10px">
        <label :for="col" style="font-size:0.9em;">{{ col }}:</label>
        <template v-if="col === 'Status'">
          <div style="display: flex; flex-direction: column;">
            <label v-for="opt in statusOptions" :key="opt" style="font-weight:normal;">
              <input
                type="checkbox"
                :value="opt"
                v-model="filters.Status"
                style="margin-right:4px;"
              />
              {{ opt }}
            </label>
          </div>
        </template>
        <template v-else-if="col === 'Date Added' || col === 'Follow Up'">
        <input
            :id="col"
            v-model="filters[col]"
            type="date"
            style="width:130px; font-size:1em; padding: 6px 10px;"
        />
        </template>
        <template v-else-if="col === 'Components'">
          <v-select
            :id="col"
            v-model="filters[col]"
            :options="componentOptions"
            placeholder="Type or select component"
            :clearable="true"
            :searchable="true"
            style="width: 180px; font-size: 0.7em;"
            :inputProps="{ style: 'font-size:0.7em;' }"
          />
        </template> 
        <template v-else>
          <input
            :id="col"
            v-model="filters[col]"
            :placeholder="'Filter ' + col"
            :style="col === 'Form No.' 
              ? 'width:90px; font-size:1em; padding: 6px 10px;' 
              : col === 'FG' 
                ? 'width:180px; font-size:1em; padding: 6px 10px;' 
                : 'width:140px; font-size:1em; padding: 6px 10px;'"
          />
        </template>
    </div>
    <div style="display:inline-block; margin-left: 20px;">
      <label style="font-size:0.9em;">Material Allocation:</label>
      <div style="display: flex; flex-direction: column;">
        <label style="font-weight:normal;">
          <input
            type="checkbox"
            value="Available"
            v-model="materialAllocationFilter"
            style="margin-right:4px;"
          />
          Available
        </label>
        <label style="font-weight:normal;">
          <input
            type="checkbox"
            value="Short"
            v-model="materialAllocationFilter"
            style="margin-right:4px;"
          />
          Short
        </label>
      </div>
    </div>
    <div v-if="materialAllocation.lastUpdated" style="color:#888; font-size:0.95em; margin-bottom:8px;">
      Order & Material allocation last updated: {{ new Date(materialAllocation.lastUpdated).toLocaleString() }}
      <button @click="restoreDefaults" class="restore-btn" style="margin-left: 1em;">Restore Default Filters</button>
    </div>
        

    </div>

    <table style="table-layout: fixed; width: 100%;">
      <thead>
        <tr>
          <th v-for="col in columns" :key="col" :style="{ width: columnWidths[col] || '24mm' }">
            <template v-if="col === 'Urgent'">
              <div>
                <label style="font-weight:normal;">
                  <input
                    type="checkbox"
                    value="Urgent"
                    v-model="filters.Urgent"
                    style="margin-right:4px;"
                    checked
                  />
                  Urgent
                </label>
              </div>
            </template>
            <template v-else>
              {{ col }}
              <template v-if="col === 'Date Added'">
                <button @click="toggleDateAddedSort" style="margin-left:4px; font-size:0.8em;">
                  <span v-if="dateAddedSortAsc">▲</span>
                  <span v-else>▼</span>
                </button>
              </template>
              <template v-else-if="col === 'Date sent for assembly'">
                <button @click="toggleDateSentSort" style="margin-left:4px; font-size:0.8em;">
                  <span v-if="dateSentSort === 'asc'">▲</span>
                  <span v-else>▼</span>
                </button>
              </template>
              <template v-else-if="col === 'Follow Up'">
                <button @click="toggleFollowUpSort" style="margin-left:4px; font-size:0.8em;">
                  <span v-if="followUpSortAsc">▲</span>
                  <span v-else>▼</span>
                </button>
              </template>
              <template v-else-if="col === 'Completion Date'">
                <button @click="toggleCompletionDateSort" style="margin-left:4px; font-size:0.8em;">
                  <span v-if="completionDateSort === 'asc'">▲</span>
                  <span v-else>▼</span>
                </button>
              </template>
            </template>
          </th>
          <th :style="{ width: columnWidths['Order Prio'] }">
            Order Prio
            <button @click="toggleOrderPrioSort" style="margin-left:4px; font-size:0.8em;">
              <span v-if="orderPrioSortAsc">▲</span>
              <span v-else>▼</span>
            </button>
          </th>
          <th style="width: 40mm;">Material Allocation</th>
          <th :style="{ width: columnWidths['Actions'] }">Actions</th>
          <th :style="{ width: '40mm' }">Allocated Orders</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, idx) in filteredRows" :key="idx" :class="getRowClass(row)">
            <td v-for="col in columns" :key="col" :style="{ width: columnWidths[col] || '24mm' }">
            <template v-if="currentlyEditing === idx">
              <template v-if="col === 'Urgent'">
                <select v-model="row[col]">
                  <option value=""></option>
                  <option value="Urgent">Urgent</option>
                </select>
              </template>
              <template v-if="col === 'FG'">
  `              <v-select
                  v-model="row[col]"
                  :options="fgOptions"
                  placeholder="Type to search..."
                  :clearable="true"
                  class="inline-select"
                  style="width: 110px; min-width: 0; font-size: 0.8em;"
                />
              </template>
              <template v-else-if="col === 'Batch Size'">
              <input
                type="number"
                v-model="row[col]"
                min="1"
                step="1"
                @input="row[col] = row[col].replace?.(/\D/g, '') || row[col]"
                style="width: 80px;"
              />
            </template>
            <template v-if="col === 'Unit 1 / Unit 2'">
              <select v-model="row[col]">
                <option value=""></option>
                <option value="Unit 1">Unit 1</option>
                <option value="Unit 2">Unit 2</option>
              </select>
            </template>
           <template v-else-if="col === 'Customizations / Automations' || col === 'Machined Status' || col === 'Store Status' || col === 'Casting Status'">
            <textarea
              v-model="row[col]"
              style="width: 120px; min-height: 28px; resize: vertical; overflow: hidden;"
              @input="autoGrow($event)"
              rows="1"
            ></textarea>
          </template>
              <template v-else-if="col === 'Status'">
                {{ row[col] }}
              </template>
              <template v-else-if="col === 'Date Added'">
                {{ row[col] }}
              </template>
              <template v-else-if="col === 'Follow Up' || col === 'Date sent for assembly' || col === 'Completion Date'">
                <input type="date" v-model="row[col]" />
              </template>
            </template>
            <template v-if="col === 'Components Status'">
              <table style="width:100%; border-collapse:collapse; font-size:0.95em; table-layout:fixed;">
                <colgroup>
                  <col style="width: 25%"/>
                  <col style="width: 75%"/>
                </colgroup>
                <tbody>
                  <tr>
                    <td style="padding:2px 4px; border-bottom:1px solid #eee; word-break:break-word;"><strong>Machined</strong></td>
                    <td style="padding:2px 4px; border-bottom:1px solid #eee; word-break:break-word;">{{ row['Machined Status'] || '-' }}</td>
                  </tr>
                  <tr>
                    <td style="padding:2px 4px; border-bottom:1px solid #eee; word-break:break-word;"><strong>Store</strong></td>
                    <td style="padding:2px 4px; border-bottom:1px solid #eee; word-break:break-word;">{{ row['Store Status'] || '-' }}</td>
                  </tr>
                  <tr>
                    <td style="padding:2px 4px; word-break:break-word;"><strong>Purchase</strong></td>
                    <td style="padding:2px 4px; word-break:break-word;">{{ row['Casting Status'] || '-' }}</td>
                  </tr>
                </tbody>
              </table>
            </template>
            <template v-else-if="col === 'Batch Size'">
              {{ row[col] }}
              <br />
              <button @click="openSplitModal(row, idx)" style="margin-top:4px; font-size:0.8em;">Split Form</button>
            </template>
            <template v-else>
              {{ row[col] }}
            </template>
            </td>
            <td :style="{ width: columnWidths['Order Prio'] }">
              <template v-if="materialAllocation.allocationResults[row.ID]?.orderPrioInfo">
                <div>
                  <strong>{{ materialAllocation.allocationResults[row.ID].orderPrioInfo.planPriority }}</strong>
                </div>
              </template>
              <template v-else>
                —
              </template>
            </td>
            <td style="width: 40mm;">
              <template v-if="materialAllocation.allocationResults[row.ID]">
                <span v-if="materialAllocation.allocationResults[row.ID].allocated" style="color: green; font-weight: bold;">
                  Allocated
                </span>
                <template v-else-if="materialAllocation.allocationResults[row.ID].missing && materialAllocation.allocationResults[row.ID].missing.length">
                  <table style="width:100%; border-collapse:collapse; font-size:0.95em;">
                    <thead>
                      <tr style="background:#f6f6f6;">
                        <th style="padding:2px 4px; border-bottom:1px solid #ddd;">Short Fall</th>
                        <th style="padding:2px 4px; border-bottom:1px solid #ddd;">Need</th>
                        <th style="padding:2px 4px; border-bottom:1px solid #ddd;">Avail</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(miss, i) in materialAllocation.allocationResults[row.ID].missing" :key="i">
                        <td style="padding:2px 4px;">{{ miss.itemName }}</td>
                        <td style="padding:2px 4px; text-align:right;">{{ miss.needed }}</td>
                        <td style="padding:2px 4px; text-align:right;">{{ miss.available }}</td>
                      </tr>
                    </tbody>
                  </table>
                </template>
                <span v-else>
                  {{ materialAllocation.allocationResults[row.ID].status }}
                </span>
              </template>
              <template v-else>
                —
              </template>
            </td>
            <td :style="{ width: columnWidths['Actions'] }">
            <button @click="openEditModal(row)">Edit</button>
            <button @click="deleteRow(row, idx)" style="color:red;">Delete</button>
            <button @click="printForm(row)">Print Form</button>
            </td>
            <td :style="{ width: '40mm', padding: '0' }">
              <table v-if="materialAllocation.allocationResults[row.ID]?.allocatedOrders?.length" style="width:100%; border-collapse:collapse; font-size:0.95em;">
                <thead>
                  <tr style="background:#f6f6f6;">
                    <th style="padding:2px 4px; border-bottom:1px solid #ddd;">Order No.</th>
                    <th style="padding:2px 4px; border-bottom:1px solid #ddd;">Customer</th>
                    <th style="padding:2px 4px; border-bottom:1px solid #ddd;">Qty</th>
                    <th style="padding:2px 4px; border-bottom:1px solid #ddd;">Prio</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="order in materialAllocation.allocationResults[row.ID].allocatedOrders" :key="order.orderNo">
                    <td style="padding:2px 4px;">{{ order.orderNo }}</td>
                    <td style="padding:2px 4px;">{{ order.customer }}</td>
                    <td style="padding:2px 4px; text-align:right;">{{ order.allocatedQty }}</td>
                    <td style="padding:2px 4px; text-align:right;">{{ order.planPriority }}</td>
                  </tr>
                </tbody>
              </table>
              <span v-else style="color:#aaa;">—</span>
            </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div ref="printSection" style="display:none;">
        <h2>Assembly Order Form</h2>
        <p><strong>FG:</strong> {{ printData.FG }}</p>
        <p><strong>Quantity:</strong> {{ printData['Batch Size'] }}</p>
  </div>
  <div v-if="showSplitModal" class="modal-overlay">
    <div class="modal">
      <h3>Split Assembly Plan</h3>
      <p>Batch Size: {{ splitRow['Batch Size'] }}</p>
      <label>
        Number of splits:
        <input type="number" v-model="splitParts" min="2" max="26" @input="updateSplitParts" />
      </label>
      <div v-for="(size, i) in splitSizes" :key="i" style="margin:4px 0;">
        <label>
          Part {{ String.fromCharCode(65 + i) }} size:
          <input type="number" v-model.number="splitSizes[i]" min="1" :max="splitRow['Batch Size']" />
        </label>
      </div>
      <div style="margin-top:8px;">
        <button @click="confirmSplit">Split</button>
        <button @click="showSplitModal = false" style="margin-left:8px;">Cancel</button>
      </div>
      <div v-if="splitSizes.reduce((a,b)=>a+b,0) !== splitRow['Batch Size']" style="color:red;">
        Total must match original batch size!
      </div>
    </div>
  </div>
  <div v-if="showFormModal" class="modal-overlay">
    <div class="modal">
      <h3>{{ formMode === 'add' ? 'Add New Assembly Plan' : 'Edit Assembly Plan' }}</h3>
      <form @submit.prevent="saveForm">
        <div v-for="col in columns" :key="col" style="margin-bottom:8px;">
          <template v-if="col === 'Components Status'">
            <label style="font-weight:bold;">Machined Status</label>
            <input type="text" v-model="form['Machined Status']" />

            <label style="font-weight:bold;">Store Status</label>
            <input type="text" v-model="form['Store Status']" />

            <label style="font-weight:bold;">Casting Status</label>
            <input type="text" v-model="form['Casting Status']" />
          </template>
          <template v-else>
            <label :for="col" style="font-weight:bold;">{{ col }}</label>
            <!-- ...your existing input templates for other columns... -->
            <template v-if="col === 'Status'">
              <input type="text" v-model="form[col]" disabled />
            </template>
            <template v-else-if="col === 'Date Added'">
              <input type="date" v-model="form[col]" disabled />
            </template>
            <template v-else-if="col === 'Urgent'">
              <select v-model="form[col]">
                <option value=""></option>
                <option value="Urgent">Urgent</option>
              </select>
            </template>
            <template v-else-if="col === 'FG'">
              <v-select v-model="form[col]" :options="fgOptions" placeholder="Type to search..." :clearable="true" />
            </template>
            <template v-else-if="col === 'Batch Size'">
              <input
                type="number"
                v-model="form[col]"
                min="1"
                step="1"
                pattern="\d+"
                @input="form[col] = form[col] ? String(form[col]).replace(/\D/g, '') : ''"
                required
              />
            </template>
            <template v-else-if="col === 'Date sent for assembly' || col === 'Follow Up' || col === 'Completion Date'">
              <input type="date" v-model="form[col]" />
            </template>
            <template v-else-if="col === 'Form No.'">
              <input type="text" v-model="form[col]" disabled />
            </template>
            <template v-else>
              <input type="text" v-model="form[col]" />
            </template>
          </template>
        </div>
        <div style="margin-top:12px;">
          <button type="submit">{{ formMode === 'add' ? 'Add' : 'Save' }}</button>
          <button type="button" @click="showFormModal = false" style="margin-left:8px;">Cancel</button>
        </div>
      </form>
    </div>
  </div>
  <div v-if="saving" class="saving-overlay-simple">Saving...</div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import vSelect from "vue3-select";
import "vue3-select/dist/vue3-select.css";
import html2pdf from "html2pdf.js";
import { watch } from 'vue';

const columns = [
  'Date Added', 'Urgent', 'FG', 'Batch Size', 'Unit 1 / Unit 2',
  'Customizations / Automations', 'Components Status',
  'Date sent for assembly', 'Form No.', 'Follow Up', 'Completion Date', 'Status'
];
const filterableColumns = [
  'Date Added', 'FG', 'Form No.','Follow Up', 'Status', 'Components'
];
const filters = ref({});
filterableColumns.forEach(col => {
  if (col === 'Status') {
    filters.value[col] = ['Planned','At Assembly']; // Default: checked
  } else {
    filters.value[col] = '';
  }
});
const rows = ref([]);
filters.value.Urgent = []; // Default: unchecked
const filteredRows = computed(() => {
  let result = rows.value.filter(row =>
    filterableColumns.every(col => {
      const filterVal = filters.value[col];
      if (!filterVal || (Array.isArray(filterVal) && filterVal.length === 0)) return true;
      if (col === 'Status' || col === 'Urgent') {
        return filterVal.includes(row[col]);
      }
      if (col === 'Date Added' || col === 'Follow Up') {
        return (row[col] || '').slice(0, 10) === filterVal;
      }
      if (col === 'Components') {
        const fgName = row['FG'];
        const bom = bomList.value.find(b => b.Name === fgName);
        if (!bom || !Array.isArray(bom.Components)) return false;
        // If filter is empty, show all
        if (!filterVal) return true;
        // Check if any component's Item Name matches the selected value
        return bom.Components.some(comp => comp['Item Name'] === filterVal);
      }
      return String(row[col] || '').toLowerCase().includes(filterVal.toLowerCase());
    })
  );
  // Urgent filtering
  if (filters.value.Urgent && filters.value.Urgent.length > 0) {
    result = result.filter(row => filters.value.Urgent.includes(row.Urgent));
  }
    // --- Material Allocation filter ---
  if (materialAllocationFilter.value.length > 0) {
    result = result.filter(row => {
      const allocResult = materialAllocation.value.allocationResults[row.ID];
      const isAvailable = allocResult?.allocated;
      const isShort = allocResult?.missing && allocResult.missing.length > 0;
      return (
        (materialAllocationFilter.value.includes('Available') && isAvailable) ||
        (materialAllocationFilter.value.includes('Short') && isShort)
      );
    });
  }
  // Sorting
  if (orderPrioSort.value) {
    result = [...result].sort((a, b) => {
      const aPrio = materialAllocation.value.allocationResults[a.ID]?.orderPrioInfo?.planPriority ?? 99999;
      const bPrio = materialAllocation.value.allocationResults[b.ID]?.orderPrioInfo?.planPriority ?? 99999;
      return orderPrioSort.value === 'asc' ? aPrio - bPrio : bPrio - aPrio;
    });
  } else if (dateAddedSort.value) {
    result = [...result].sort((a, b) => {
      const aDate = new Date(a['Date Added'] || 0);
      const bDate = new Date(b['Date Added'] || 0);
      return dateAddedSort.value === 'asc' ? aDate - bDate : bDate - aDate;
    });
  } else if (dateSentSort.value) {
  result = [...result].sort((a, b) => {
    const aDate = new Date(a['Date sent for assembly'] || 0);
    const bDate = new Date(b['Date sent for assembly'] || 0);
    return dateSentSort.value === 'asc' ? aDate - bDate : bDate - aDate;
  });
  } else if (followUpSort.value) {
  result = [...result].sort((a, b) => {
    const aDate = new Date(a['Follow Up'] || 0);
    const bDate = new Date(b['Follow Up'] || 0);
    return followUpSort.value === 'asc' ? aDate - bDate : bDate - aDate;
    });
  } else if (completionDateSort.value) {
  result = [...result].sort((a, b) => {
    const aDate = new Date(a['Completion Date'] || 0);
    const bDate = new Date(b['Completion Date'] || 0);
    return completionDateSort.value === 'asc' ? aDate - bDate : bDate - aDate;
    });
  }
  return result;
});
const statusOptions = computed(() => {
  // Get unique, non-empty status values from the loaded rows
  const set = new Set(rows.value.map(row => row['Status']).filter(Boolean));
  return Array.from(set);
});
const currentlyEditing = ref(null);
const printData = ref({});
const bomList = ref([]);
const fgOptions = computed(() =>
  bomList.value
    .filter(bom => bom['Purchase Tag'] === 'FG' || bom['Purchase Tag'] === 'Bought Out')
    .map(bom => bom.Name)
    .filter(Boolean)
);
const dateAddedSort = ref(null); // null, 'asc', or 'desc'
const dateSentSort = ref(null); // null, 'asc', or 'desc'
const completionDateSort = ref(null); // null, 'asc', or 'desc'
const followUpSort = ref(null);
const orderPrioSort = ref(null);
const columnWidths = {
  'Date Added': '15mm',
  'Urgent': '10mm',
  'FG': '60mm',
  'Batch Size': '8mm',
  'Unit 1 / Unit 2': '10mm',
  'Customizations / Automations': '20mm',
  'Components Status': '60mm',
  'Date sent for assembly': '18mm',
  'Form No.': '15mm',
  'Follow Up': '15mm',
  'Completion Date': '15mm',
  'Status': '14mm',
  'Order Prio': '5mm',
  'Actions': '20mm',
  'Allocated Orders': '40mm'
};
const showSplitModal = ref(false);
const splitRow = ref(null);
const splitIdx = ref(null);
const splitParts = ref(2);
const splitSizes = ref([]);
const showFormModal = ref(false);
const formMode = ref('add'); // 'add' or 'edit'
const form = ref({
  'Date Added': '',
  'Urgent': '',
  'FG': '',
  'Batch Size': '',
  'Unit 1 / Unit 2': '',
  'Customizations / Automations': '',
  'Machined Status': '',
  'Store Status': '',
  'Casting Status': '',
  'Date sent for assembly': '',
  'Form No.': '',
  'Follow Up': '',
  'Completion Date': '',
  'Status': 'Planned',
  ID: undefined
});
const materialAllocation = ref({ allocationResults: {}, lastUpdated: null });
const componentOptions = computed(() => {
  // Flatten all Components arrays and collect unique Item Names
  const names = new Set();
  bomList.value.forEach(bom => {
    (bom.Components || []).forEach(comp => {
      if (comp['Item Name']) names.add(comp['Item Name']);
    });
  });
  return Array.from(names).sort();
});
const STORAGE_KEY = 'assemblyPlanState';
const materialAllocationFilter = ref([]);
const saving = ref(false);

async function deleteRow(row) {
  if (!confirm('Are you sure you want to delete this row?')) return;
  saving.value = true;
  try {
    const res = await fetch(`${process.env.VUE_APP_BACKEND_URL}/api/assembly-plan/${row.ID}`, { method: 'DELETE' });
    if (res.ok) {
      await reloadRows();
    } else {
      alert('Failed to delete');
    }
  } finally {
    saving.value = false;
  }
}
function autoGrow(event) {
  const el = event.target;
  el.style.height = "auto";
  el.style.height = (el.scrollHeight) + "px";
}
function getFinancialYearSuffix(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  let year = date.getFullYear();
  const month = date.getMonth() + 1; // JS months are 0-based
  // If before April, use previous year as start
  if (month < 4) year -= 1;
  const nextYearShort = (year + 1).toString().slice(-2);
  const thisYearShort = year.toString().slice(-2);
  return `/${thisYearShort}-${nextYearShort}`;
}
async function getNextFormNoFromBackend(dateSentForAssembly) {
  const res = await fetch(`${process.env.VUE_APP_BACKEND_URL}/api/assembly-plan/next-form-no`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ dateSentForAssembly })
  });
  const data = await res.json();
  return data.formNo;
}
async function reloadRows() {
  const res = await fetch(`${process.env.VUE_APP_BACKEND_URL}/api/assembly-plan`);
  rows.value = await res.json();
}
function toggleDateAddedSort() {
  if (dateAddedSort.value === 'asc') dateAddedSort.value = 'desc';
  else dateAddedSort.value = 'asc';
  // Reset others
  followUpSort.value = null;
  orderPrioSort.value = null;
  dateSentSort.value = null;
  completionDateSort.value = null;
}
function toggleDateSentSort() {
  if (dateSentSort.value === 'asc') dateSentSort.value = 'desc';
  else dateSentSort.value = 'asc';
  // Reset others
  dateAddedSort.value = null;
  followUpSort.value = null;
  orderPrioSort.value = null;
  completionDateSort.value = null;
}
function toggleFollowUpSort() {
  if (followUpSort.value === 'asc') followUpSort.value = 'desc';
  else followUpSort.value = 'asc';
  dateAddedSort.value = null;
  orderPrioSort.value = null;
  dateSentSort.value = null;
  completionDateSort.value = null;
}
function toggleCompletionDateSort() {
  if (completionDateSort.value === 'asc') completionDateSort.value = 'desc';
  else completionDateSort.value = 'asc';
  // Reset others
  dateAddedSort.value = null;
  dateSentSort.value = null;
  followUpSort.value = null;
  orderPrioSort.value = null;
}
function toggleOrderPrioSort() {
  if (orderPrioSort.value === 'asc') orderPrioSort.value = 'desc';
  else orderPrioSort.value = 'asc';
  dateAddedSort.value = null;
  followUpSort.value = null;
  dateSentSort.value = null;
  completionDateSort.value = null;
}
function getRowClass(row) {
  let classes = [];
  if (row['Status'] === 'Completed') classes.push('row-completed');
  else if (row['Status'] === 'At Assembly') classes.push('row-assembly');
  else if (row['Status'] === 'Planned') classes.push('row-planned');
  if (row['Urgent'] === 'Urgent') classes.push('row-urgent');
  return classes.join(' ');
}
function getBomComponentsByName(fgName) {
  const bom = bomList.value.find(b => b.Name === fgName);
  return bom && Array.isArray(bom.Components) ? bom.Components : [];
}
function isComponentBatchWise(componentName) {
  const compObj = bomList.value.find(b => b.Name === componentName);
  return compObj && compObj['Is Batch Wise'] === 'Yes';
}
function openSplitModal(row, idx) {
  showSplitModal.value = true;
  splitRow.value = { ...row }; // shallow copy
  splitIdx.value = idx;
  splitParts.value = 2;
  splitSizes.value = Array(2).fill(Math.floor(row['Batch Size'] / 2));
  // Adjust last part to match total
  splitSizes.value[splitSizes.value.length - 1] += row['Batch Size'] % 2;
}
function updateSplitParts() {
  const n = Number(splitParts.value);
  if (n < 2) return;
  splitSizes.value = Array(n).fill(Math.floor(splitRow.value['Batch Size'] / n));
  splitSizes.value[n - 1] += splitRow.value['Batch Size'] % n;
}
async function confirmSplit() {
  // Validate
  const total = splitSizes.value.reduce((a, b) => a + b, 0);
  if (total !== splitRow.value['Batch Size']) return;
  saving.value = true;
  try {
    // If Form No. is blank, just split without updating Form No.
    if (!splitRow.value['Form No.']) {
      // 1. Update the original row to be the first split
      const aRow = {
        ...splitRow.value,
        'Batch Size': splitSizes.value[0]
        // Form No. remains blank
      };
      await fetch(`${process.env.VUE_APP_BACKEND_URL}/api/assembly-plan/${aRow.ID}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(aRow)
      });

      // 2. POST new rows for the rest
      for (let i = 1; i < splitSizes.value.length; i++) {
        const newRow = {
          ...splitRow.value,
          'Batch Size': splitSizes.value[i],
          'Form No.': '', // keep blank
          ID: undefined // Let backend assign new ID
        };
        await fetch(`${process.env.VUE_APP_BACKEND_URL}/api/assembly-plan`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(newRow)
        });
      }
      await reloadRows();
      showSplitModal.value = false;
      return;
    }

    // --- Handle Form No. with suffix logic ---
    const origFormNo = splitRow.value['Form No.'];
    const match = String(origFormNo).match(/^(\d+)([A-Z]?)(\/\d{2}-\d{2})$/);
    let baseNum = origFormNo, fy = '';
    if (match) {
      baseNum = match[1];
      fy = match[3];
    }

    // Find all used suffix letters (A-Z)
    const usedSuffixes = new Set(
      rows.value
        .map(row => {
          const m = String(row['Form No.'] || '').match(/^(\d+)([A-Z]?)(\/\d{2}-\d{2})$/);
          return m && m[1] === baseNum && m[3] === fy ? m[2] : null;
        })
        .filter(s => s !== null && s !== '')
    );

    // Determine the suffix of the original row (if any)
    const origSuffix = match && match[2] ? match[2] : 'A';

    // Only update the Form No. if the original row has NO suffix
    let updatedRow;
    if (!match[2]) {
      // No suffix: assign 'A'
      usedSuffixes.add('A');
      updatedRow = {
        ...splitRow.value,
        'Batch Size': splitSizes.value[0],
        'Form No.': `${baseNum}A${fy}`
      };
    } else {
      // Already has a suffix: leave as is
      usedSuffixes.add(origSuffix);
      updatedRow = {
        ...splitRow.value,
        'Batch Size': splitSizes.value[0]
        // Form No. unchanged
      };
    }
    await fetch(`${process.env.VUE_APP_BACKEND_URL}/api/assembly-plan/${updatedRow.ID}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updatedRow)
    });

    // --- 2. POST new rows for the rest, assigning next available suffixes ---
    let suffixCharCode = 66; // 'B'
    for (let i = 1; i < splitSizes.value.length; i++) {
      // Find the next unused suffix letter
      while (usedSuffixes.has(String.fromCharCode(suffixCharCode))) {
        suffixCharCode++;
        if (suffixCharCode > 90) throw new Error('Ran out of suffix letters!');
      }
      const suffix = String.fromCharCode(suffixCharCode);
      usedSuffixes.add(suffix);
      suffixCharCode++;

      const newRow = {
        ...splitRow.value,
        'Batch Size': splitSizes.value[i],
        'Form No.': `${baseNum}${suffix}${fy}`,
        ID: undefined // Let backend assign new ID
      };
      await fetch(`${process.env.VUE_APP_BACKEND_URL}/api/assembly-plan`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newRow)
      });
    }
    await reloadRows();
    showSplitModal.value = false;
  } finally {
    saving.value = false;
  }
}
function openAddModal() {
  formMode.value = 'add';
  Object.assign(form.value, {
    'Date Added': new Date().toISOString().slice(0, 10),
    'Urgent': '',
    'FG': '',
    'Batch Size': '',
    'Unit 1 / Unit 2': '',
    'Customizations / Automations': '',
    'Machined Status': '',
    'Store Status': '',
    'Casting Status': '',
    'Date sent for assembly': '',
    'Form No.': '',
    'Follow Up': '',
    'Completion Date': '',
    'Status': 'Planned',
    ID: undefined
  });
  showFormModal.value = true;
}
function openEditModal(row) {
  formMode.value = 'edit';
  Object.assign(form.value, JSON.parse(JSON.stringify(row)));
  showFormModal.value = true;
}
async function saveForm() {
    // Validation for FG and Batch Size
  if (
    !form.value['FG'] ||
    String(form.value['FG']).trim() === '' ||
    form.value['Batch Size'] === undefined ||
    form.value['Batch Size'] === null ||
    String(form.value['Batch Size']).trim() === '' ||
    isNaN(Number(form.value['Batch Size'])) ||
    Number(form.value['Batch Size']) <= 0
  ) {
    alert('FG and Batch Size are required and Batch Size must be a positive number.');
    return;
  }

  // Get Form No. from backend if needed
  if (form.value['Date sent for assembly']) {
    const suffix = getFinancialYearSuffix(form.value['Date sent for assembly']);
    if (!form.value['Form No.'] || !String(form.value['Form No.']).endsWith(suffix)) {
      form.value['Form No.'] = await getNextFormNoFromBackend(form.value['Date sent for assembly']);
    }
  } else {
    form.value['Form No.'] = '';
  }

  // Auto-generate Status
  if (form.value['Completion Date']) {
    form.value['Status'] = 'Completed';
  } else if (form.value['Date sent for assembly']) {
    form.value['Status'] = 'At Assembly';
  } else if (form.value['Date Added']) {
    form.value['Status'] = 'Planned';
  } else {
    form.value['Status'] = '';
  }

  // Get Form No. from backend if needed
  if (form.value['Date sent for assembly']) {
    const suffix = getFinancialYearSuffix(form.value['Date sent for assembly']);
    if (!form.value['Form No.'] || !String(form.value['Form No.']).endsWith(suffix)) {
      form.value['Form No.'] = await getNextFormNoFromBackend(form.value['Date sent for assembly']);
    }
  } else {
    form.value['Form No.'] = '';
  }

  // Ensure Batch Size is a number
  form.value['Batch Size'] = Number(form.value['Batch Size']);

  const isNew = !form.value.ID;
  const url = isNew
    ? `${process.env.VUE_APP_BACKEND_URL}/api/assembly-plan`
    : `${process.env.VUE_APP_BACKEND_URL}/api/assembly-plan/${form.value.ID}`;
  const method = isNew ? 'POST' : 'PUT';

  saving.value = true;
  try{
    const res = await fetch(url, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form.value)
    });
    if (res.ok) {
      showFormModal.value = false;
      await reloadRows();
    } else {
      alert('Failed to save');
    }
  } finally {
      saving.value = false;
  }
}
function restoreDefaults() {
  // Reset filters
  filterableColumns.forEach(col => {
    if (col === 'Status') {
      filters.value[col] = ['Planned','At Assembly'];
    } else {
      filters.value[col] = '';
    }
  });
  filters.value.Urgent = [];
  // Reset sorting
  dateAddedSort.value = null;
  dateSentSort.value = null;
  completionDateSort.value = null;
  followUpSort.value = null;
  orderPrioSort.value = null;
  materialAllocationFilter.value = [];
  // Save to localStorage
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      filters: filters.value,
      dateAddedSort: dateAddedSort.value,
      dateSentSort: dateSentSort.value,
      completionDateSort: completionDateSort.value,
      followUpSort: followUpSort.value,
      orderPrioSort: orderPrioSort.value,
      materialAllocationFilter: materialAllocationFilter.value
    })
  );
}
function printForm(row) {
  if (!row['Form No.'] || !row['Form No.'].trim()) {
    alert('Please fill out the Form No. before printing.');
    return;
  }
  const components = getBomComponentsByName(row.FG);
  // Table header
  const headerRows = `
    <tr>
      <th style="width:88mm; font-weight:normal; font-size:10pt; text-align:left;">
        <strong>FG:</strong> ${row.FG}
      </th>
      <th style="width:22mm; font-weight:normal; font-size:10pt; text-align:left;">
        <strong>Qty:</strong> ${row['Batch Size']}
      </th>
      <th style="width:18mm; height: 7mm; font-size:7.5pt; text-align:left; white-space:nowrap; overflow:visible; color:#cccccc;">Batch Qty &rarr;</th>
      ${'<th style="width:18mm; height: 7mm;"></th>'.repeat(7)}
    </tr>
    <tr>
      <th rowspan="2" style="width:88mm;">Components</th>
      <th rowspan="2" style="width:22mm;">Quantity</th>
      <th style="width:18mm; height: 7mm; font-size:7.5pt; text-align:left; white-space:nowrap; overflow:visible; color:#cccccc;">Sr. No. From &rarr;</th>
      ${'<th style="width:18mm; height: 7mm;"></th>'.repeat(7)}
    </tr>
    <tr>
      <th style="width:18mm; height: 7mm; font-size:7.5pt; text-align:left; white-space:nowrap; overflow:visible; color:#cccccc;">Sr. No. Up To &rarr;</th>
      ${'<th style="width:18mm; height: 7mm;"></th>'.repeat(7)}
    </tr>
  `;
  // Table body
  let rowsHtml = '';
  components.forEach(comp => {
    const batchWise = isComponentBatchWise(comp['Item Name']);
    const itemName = comp['Item Name'] || '';
    const qty = (comp['Quantity'] && row['Batch Size']) ? comp['Quantity'] * row['Batch Size'] : comp['Quantity'] || '';
    const itemNameCell = `<td>${itemName}</td>`;
    const qtyCell = `<td>${qty}</td>`;
    const extraCells = batchWise ? '<td></td>'.repeat(8) : '';
    rowsHtml += `<tr>${itemNameCell}${qtyCell}${extraCells}</tr>`;
  });
  // Components Table
  const componentsTable = components.length ? `
    <table class="components-table">
      <thead>${headerRows}</thead>
      <tbody>${rowsHtml}</tbody>
    </table>
  ` : '';
  // Data Entry Table
  const dataEntryTable = `
    <table class="data-entry-table">
      <tr><th>Valve Setting</th><td></td></tr>
      <tr><th>Body Fastener Tightening Torque</th><td></td></tr>
      <tr><th>Antistatic 100% Check</th><td></td></tr>
      <tr><th>Valve Torque</th><td></td></tr>
      <tr><th>Valve Cleanliness</th><td></td></tr>
    </table>
    <div class="assembler-sign"><strong>Assembler:</strong> ___________________________</div>
  `;
  // HTML
  const html = `
  <div class="pdf-root" style="position:relative; width:277mm; height:188mm; background:white; overflow:hidden;">
    <div class="logo-top-left">
      <img src="/logo.png" alt="Company Logo" class="logo-img" />
    </div>
    <div class="note-top">
      No information on the sheet must be left blank. If you do not know how to fill out sheet, request help from your team.
      For non-standard orders, final inspection must be done against customer approved GAD only. Design team can provide drawings.<br>
      For customized / automated valves, this sheet must be used in addition to the "Customization Sheet".
    </div>
    <div class="title">Assembly Datasheet</div>
    <div class="form-info">
      <span><strong>Form No.:</strong> ${row['Form No.']}</span>
      <span><strong>Date sent for Assembly:</strong> ${row['Date sent for assembly']}</span>
      <span><strong>Issuer's sign:</strong> ____________________</span>
      <span><strong>OA No. / Customer:</strong> ____________________</span>
    </div>
    <div class="components-table-wrap">
      ${componentsTable}
    </div>
    <div class="data-entry-wrap">
      ${dataEntryTable}
    </div>
    <style>
      /* ...your CSS styles from <style> in the HTML string... */
      @page { size: A4 landscape }
      html, body {
        width: 260mm;
        height: 188mm;
        padding: 0;
        overflow: hidden;
        box-sizing: border-box;
      }
      .title {
        position: absolute;
        top: 10mm;
        left: 0;
        width: 100%;
        text-align: center;
        font-size: 20pt;
        font-weight: bold;
        letter-spacing: 1px;
      }
      .note-top {
        position: absolute;
        top: 0mm; left: 0; width: 100%;
        text-align: center;
        font-size: 7pt;
        color: #444;
        z-index: 10;
      }
      .form-info {
        position: absolute;
        top: 26mm; left: 0mm; width: 100%;
        text-align: left;
        font-size: 10pt;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        gap: 12mm;
      }
      .components-table-wrap {
        position: absolute;
        top: 36mm; left: 0mm; width: 170mm;
      }
      .components-table {
        width: 100%;
        font-size: 10pt;
        border-collapse: collapse;
        table-layout: fixed;
      }
      .components-table th, .components-table td {
        border: 1px solid #333;
        padding: 1mm 1mm;
        text-align: left;
        background: #fafbfc;
        word-break: break-word;
      }
      .data-entry-wrap {
        position: absolute;
        top: 140mm; left: 170mm; width: 90mm;
      }
      .data-entry-table {
        width: 100%;
        font-size: 10pt;
        text-align: right;
        border-collapse: collapse;
      }
      .data-entry-table th, .data-entry-table td {
        border: 1px solid #333;
        padding: 1mm 1mm;
        min-width: 22mm;
        background: #f9f9f9;
      }
      .assembler-sign {
        margin-top: 10mm;
        text-align: right;
        font-size: 11pt;
        width: 100%;
      }
      .logo-top-left {
        position: absolute;
        top: 6mm;
        left: 20mm;
        z-index: 20;
        width: 32mm;
        height: 18mm;
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }
      .logo-top-left img {
        max-height: 100%;
        max-width: 100%;
        width: auto;
        height: auto;
        object-fit: contain;
        display: block;
      }
    </style>
    </div>
  `;

  // Print logic
  const printSection = document.createElement('div');
  printSection.innerHTML = html;
  document.body.appendChild(printSection);

    // Use html2pdf on the new div
  html2pdf()
    .set({
      margin: [10, 10, 10, 10],
      filename: `${row['Form No.'] || 'AssemblyForm'}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' }
    })
    .from(printSection)
    .outputPdf('blob')
    .then(async (pdfBlob) => {
      document.body.removeChild(printSection);

      // 1. Open PDF for user
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, '_blank');
      setTimeout(() => URL.revokeObjectURL(pdfUrl), 10000);

      // 2. Convert Blob to base64
      const base64 = await new Promise(resolve => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result.split(',')[1]);
        reader.readAsDataURL(pdfBlob);
      });

      // 3. Send to backend for SharePoint upload
      const fileName = `${row['Form No.']}.pdf`;
      await fetch(`${process.env.VUE_APP_BACKEND_URL}/api/assembly-plan/upload-pdf`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          fileName,
          pdfBase64: base64
        })
      });
      // Optionally, handle response and show a message to the user
    });
}

onMounted(async () => {

  // Restore state
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved) {
    const state = JSON.parse(saved);
    Object.assign(filters.value, state.filters || {});
    dateAddedSort.value = state.dateAddedSort ?? null;
    dateSentSort.value = state.dateSentSort ?? null;
    completionDateSort.value = state.completionDateSort ?? null;
    followUpSort.value = state.followUpSort ?? null;
    orderPrioSort.value = state.orderPrioSort ?? null;
    materialAllocationFilter.value = state.materialAllocationFilter ?? [];
  }

  // Fetch assembly plan rows
  const res = await fetch(`${process.env.VUE_APP_BACKEND_URL}/api/assembly-plan`);
  rows.value = await res.json();

  // Fetch BOM list
  const bomRes = await fetch(`${process.env.VUE_APP_BACKEND_URL}/api/bom`);
  bomList.value = await bomRes.json();

  // // Fetch Material Allocation
  const allocRes = await fetch(`${process.env.VUE_APP_BACKEND_URL}/api/assembly-plan/material-allocation`);
  materialAllocation.value = await allocRes.json();
});

watch(
  [filters, dateAddedSort, dateSentSort, completionDateSort, followUpSort, orderPrioSort, materialAllocationFilter],
  () => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        filters: filters.value,
        dateAddedSort: dateAddedSort.value,
        dateSentSort: dateSentSort.value,
        completionDateSort: completionDateSort.value,
        followUpSort: followUpSort.value,
        orderPrioSort: orderPrioSort.value,
        materialAllocationFilter: materialAllocationFilter.value,
      })
    );
  },
  { deep: true }
);

</script>

<style scoped>
td input,
td select {
  max-width: 120px;
  width: 100%;
  box-sizing: border-box;
  font-size: 1em;
}
.row-completed {
  background-color: #d0f5d8 !important; /* light green */
}
.row-assembly {
  background-color: #e3f2fd !important; /* light blue */
}
.row-planned {
  background-color: #ffe4ec !important; /* light pink */
}
.row-urgent {
  font-weight: bold;
  color: crimson;
}
.modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal {
  background: #fff;
  padding: 32px 28px 24px 28px;
  border-radius: 14px;
  box-shadow: 0 8px 32px rgba(26,35,126,0.18);
  min-width: 340px;
  max-width: 96vw;
  width: 400px;
  position: relative;
  animation: modalFadeIn 0.25s;
}

@keyframes modalFadeIn {
  from { opacity: 0; transform: translateY(30px);}
  to { opacity: 1; transform: translateY(0);}
}

.modal h3 {
  margin-top: 0;
  margin-bottom: 18px;
  font-size: 1em;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #1a237e;
}

.modal label {
  display: block;
  margin-bottom: 4px;
  font-weight: 300;
  color: #333;
  font-size: 0.9em;
}

.modal input,
.modal select,
.modal textarea {
  width: 100%;
  padding: 4px 5px;
  margin-bottom: 2px;
  border: 0.8px solid #bdbdbd;
  border-radius: 5px;
  font-size: 0.8em;
  background: #f7f9fa;
  transition: border-color 0.2s;
}

.modal input:focus,
.modal select:focus,
.modal textarea:focus {
  border-color: #1976d2;
  outline: none;
  background: #fff;
}

.modal button[type="submit"] {
  background: #1976d2;
  color: #fff;
  border: none;
  padding: 10px 26px;
  border-radius: 5px;
  font-size: 1.1em;
  font-weight: 500;
  cursor: pointer;
  margin-right: 10px;
  transition: background 0.2s;
}

.modal button[type="submit"]:hover {
  background: #1565c0;
}

.modal button[type="button"] {
  background: #eee;
  color: #333;
  border: none;
  padding: 10px 18px;
  border-radius: 5px;
  font-size: 1em;
  cursor: pointer;
  transition: background 0.2s;
}

.modal button[type="button"]:hover {
  background: #e0e0e0;
}
.restore-btn {
  margin-top: 0.5em;
  padding: 0.5em 1.2em;
  background: #3182ce;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: background 0.2s;
}
.restore-btn:hover {
  background: #225ea8;
}
.saving-overlay-simple {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  font-weight: 600;
  color: #fff;
  z-index: 10000;
  letter-spacing: 1px;
}
</style>